// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_3zDp9ilHYZ_2qnOCHmbnKm","columnTitle":"_3ROLb0DNEaqZQX75s9uY1g"};